import { createApiMutation } from "../../generated-factory";
import { apiClientManager } from "@app/stores/api-manager";
import type { UseGetPresignedUrl1Request, UseGetPresignedUrl1Data, UseUploadFileRequest, UseUploadFileData, UseUploadMultipleFilesRequest, UseUploadMultipleFilesData } from "@api/@types/file";

export const useGetPresignedUrl1 = createApiMutation<UseGetPresignedUrl1Data, UseGetPresignedUrl1Request>({
  mutationFn: (req) => apiClientManager.apis.file.getPresignedUrl1(req as UseGetPresignedUrl1Request),
});

export const useUploadFile = createApiMutation<UseUploadFileData, UseUploadFileRequest>({
  mutationFn: (req) => apiClientManager.apis.file.uploadFile(req as UseUploadFileRequest),
});

export const useUploadMultipleFiles = createApiMutation<UseUploadMultipleFilesData, UseUploadMultipleFilesRequest>({
  mutationFn: (req) => apiClientManager.apis.file.uploadMultipleFiles(req as UseUploadMultipleFilesRequest),
});

export type { UseGetPresignedUrl1Request, UseGetPresignedUrl1Data, UseUploadFileRequest, UseUploadFileData, UseUploadMultipleFilesRequest, UseUploadMultipleFilesData } from "@api/@types/file";
